// extracted by mini-css-extract-plugin
export default {"box_wrap":"style_box_wrap__rU6Xz","left_box":"style_left_box__2Igad","right_box":"style_right_box__54bfC"};